import { atom } from 'nanostores';
import type { UserData } from '~/utils/OauthHelper';

// Define the initial state using that type
interface IntegrationState {
  userData: UserData | null;
}

// Create a store with the initial state
const userDataStore = atom<IntegrationState>({ userData: null });

// Function to set user data
export function setUserData(userData: UserData) {
  // console.log('setting user data', userData);

  userDataStore.set({ userData });
}

// Function to clear user data
export function clearUserData() {
  userDataStore.set({ userData: null });
}

// Export the store
export { userDataStore };
